<template>
  <v-data-table
    style="background: transparent;"
    :headers="headers"
    :items="targets"
    hide-default-footer
    :loading="loading"
    id="table_targets"
    mobile-breakpoint=""
  >
    <template
      v-if="targets.length"
      #body="{ items }"
    >
      <tbody>
        <tr
          v-for="(item, index) in items"
          :key="index"
        >
          <td>
            <span class="font-weight-medium">{{ item }}</span>
          </td>
          <td>
            <v-row no-gutters justify="end">
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn icon v-on="on" @click="deleteIp(item)">
                    <v-icon>
                      delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $tc('remove') }}
                </span>
              </v-tooltip>
            </v-row>
          </td>
        </tr>
      </tbody>
    </template>
    <template v-else>
      <td
        v-if="loading"
      >
        {{ $t('searching') }}
      </td>

      <td
        v-else
      >
        {{ $t('$vuetify.noDataText') }}
      </td>
    </template>
  </v-data-table>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      search: null,
      loading: false,
      headers: [
        {
          text: this.$tc('ip'),
          align: 'start',
          value: 'name'
        },
        {
          text: this.$tc('action', 2),
          align: 'right',
          sortable: false,
          value: null
        }
      ]
    }
  },
  computed: {
    targets () {
      return this.$store.state.hsm.netInfo.snmp.targets
    }
  },
  methods: {
    deleteIp (target) {
      this.$emit('deleteIp', { target })
    }
  }
}
</script>
